module.exports = __webpack_public_path__ + "images/sort-up-hover-red-554fd44b.svg";